<template>
    <div class="cel_navigation"  :class="{'open': naviOpen}">
            <div class="celerart-navigation_title">
                <p>Nav</p>
            </div>
            <div id="celerart-navigation_nav-icon2"
                 class="closes"
                 @click="naviOpen = !naviOpen"
                 :class="{'open': naviOpen}"
            >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <ul class="celerart-navigation_nav" :class="{'open': naviOpen}">
                <li class="celerart-navigation_nav-item">
                    <router-link :to="{name: 'HomeNew'}">
                        HomeNew
                    </router-link>
                </li>
                <li class="celerart-navigation_nav-item">
                    <router-link :to="{name: 'OfferListNew'}">
                        OfferListNew
                    </router-link>
                </li>
                <li class="celerart-navigation_nav-item">
                    <router-link :to="{name: 'checkoutNew'}">
                        checkoutNew
                    </router-link>
                </li>
                <li class="celerart-navigation_nav-item">
                    <router-link :to="{name: 'RateNew'}">
                        RateNew
                    </router-link>
                </li>
                <li class="celerart-navigation_nav-item">
                    <router-link :to="{name: 'PriceOutdate'}">
                        PriceOutdate
                    </router-link>
                </li>
                <li class="celerart-navigation_nav-item">
                    <router-link :to="{name: 'InstructionPage'}">
                        InstructionPage
                    </router-link>
                </li>
                <li class="celerart-navigation_nav-item">
                    <router-link :to="{name: 'AffiliatePage'}">
                        AffiliatePage
                    </router-link>
                </li>
                <li class="celerart-navigation_nav-item">
                    <router-link :to="{name: 'Landing'}">
                        Landing
                    </router-link>
                </li>
                <li class="celerart-navigation_nav-item">
                    <router-link :to="{name: 'TemplateList'}">
                        TemplateList
                    </router-link>
                </li>
                <li class="celerart-navigation_nav-item">
                    <button class="btn btn-gray small" @click="old = !old">open old</button>
                </li>
                <transition name="fade">
                    <li v-if="old" class="celerart-navigation_nav-item">
                        <ul>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'index'}">
                                    Index
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'about'}">
                                    about
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'companylist'}">
                                    companylist
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{path: '/company-page/1'}">
                                    companyPage
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'terms'}">
                                    terms
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'contact'}">
                                    contact
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'offer'}">
                                    offer
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'UserData'}">
                                    UserData
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'confirm'}">
                                    DataConfirmation
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'NotFound'}">
                                    NotFound
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'Rate'}">
                                    Rate
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'ThankYou'}">
                                    ThankYou
                                </router-link>
                            </li>
                            <li class="celerart-navigation_nav-item">
                                <router-link :to="{name: 'OldBrowser'}">
                                    OldBrowser
                                </router-link>
                            </li>
                        </ul>
                    </li>

                </transition>

            </ul>
    </div>
</template>

<script>
    // delete
    // component use only for develop
    export default {
        name: "navi",
        data: function(){
            return {
                naviOpen: false,
                old: false
            }
        }
    }
</script>
